import React, { useEffect, useState } from "react";
import { Marker, useMap } from "react-leaflet";
import { pinDiv } from "./Icon";

// finds user's current position and displays it on the map
// Does not follow the user if they move
const UserLocation = () => {
	const [position, setPosition] = useState(null);

	const mapHook = useMap();

	useEffect(() => {
		mapHook.locate().on("locationfound", function (e) {
			setPosition(e.latlng);
		});
	}, []);
	if (!position) return null;

	return <Marker icon={pinDiv(null, "user-pin")} position={position}></Marker>;
};

export default UserLocation;
